module.exports = __webpack_public_path__ + "static/media/customer-hiw-1.cacfe302.png";